<fw-dialog width="small">
  <fw-dialog-header>
    <h3>{{ (storageId ? 'storageEditDialog.editTitle' : 'storageEditDialog.addTitle') | translate }}</h3>
  </fw-dialog-header>
  <fw-dialog-content>
    <input type="file" #fileInput (change)="onFileSelected($event)" hidden />

    <form [formGroup]="form" class="storage-edit-dialog-content">
      <ng-container *ngIf="statusCheck">
        <ng-container [ngSwitch]="statusCheck.status">
          <fw-alert *ngSwitchCase="storageCheckStatus.Success" class="storage-edit-dialog-content-toast"
            severity="success" icon="done-check-tracked" variant="outlined" [showClose]="true" (close)="hideToast()"
            [title]="'storageEditDialog.testConnection.success' | translate">
          </fw-alert>
          <fw-alert *ngSwitchCase="storageCheckStatus.Failed" class="storage-edit-dialog-content-toast" severity="error"
            icon="warning-circle" variant="outlined" [showClose]="true" (close)="hideToast()"
            [title]="'storageEditDialog.testConnection.failed' | translate">
            <fw-tooltip [title]="statusCheck.reason" position="below" color="light" [maxWidth]="600">
              <p class="storage-edit-dialog-content-toast-text">{{statusCheck.reason}}
              </p>
            </fw-tooltip>
          </fw-alert>
          <fw-alert *ngSwitchDefault class="storage-edit-dialog-content-toast" severity="info" icon="rotate-refresh"
            variant="outlined" [showClose]="true" (close)="hideToast()"
            [title]="'storageEditDialog.testConnection.inprogress' | translate">
            <fw-tooltip [maxWidth]="600" [title]="statusCheck.reason || (statusCheck.status | titlecase)">
              <p class="storage-edit-dialog-content-toast-text">
                {{statusCheck.reason || (statusCheck.status | titlecase)}}</p>
            </fw-tooltip>
          </fw-alert>
        </ng-container>
      </ng-container>
      <div class="storage-edit-dialog-content-item">
        <fw-form-heading [description]="'storageEditDialog.descriptions.storageLabel' | translate"
          [title]="'storageEditDialog.labels.storageLabel' | translate"></fw-form-heading>
        <fw-wrapped-input [errorText]="getLabelError()">
          <fw-text-input [placeholder]="'storageEditDialog.placeholders.storageLabel' | translate"
            [formControlName]="storageDialogControllers.Label">
          </fw-text-input>
        </fw-wrapped-input>

      </div>
      <div *ngIf="!storageId" class="storage-edit-dialog-content-item">
        <fw-form-heading [description]="'storageEditDialog.descriptions.provider'| translate"
          [title]="'storageEditDialog.labels.provider' | translate"></fw-form-heading>
        <fw-select [placeholder]="'storageEditDialog.placeholders.provider' | translate"
          [formControlName]="storageDialogControllers.ProviderType" optionsWidth="567px" width="100%">
          <fw-menu-item *ngFor="let provider of providerOptions" [value]="provider"
            [title]="('storageEditDialog.providerOptions.' + provider) | translate ">
          </fw-menu-item>
        </fw-select>
      </div>
      <ng-container formGroupName="providerConfig">
        <div *ngFor="let input of inputsConfig" class="storage-edit-dialog-content-item">
          <div class="storage-edit-dialog-content-item-header">
            <div class="storage-edit-dialog-content-item-header-label"> {{input.label | translate}}
              <ng-container *ngIf="input.info || input.errorInfo">
                <div #popoverTrigger>
                  <fw-icon
                    [color]="form.get(storageDialogControllers.ProviderConfig).get(input.controller)?.errors?.errorWithInfo ? 'red' : 'primary'">
                    information-circle</fw-icon>
                </div>
                <fw-popover [trigger]="popoverTrigger" position="above" action="mouseenter">
                  <div
                    [innerHTML]="(form.get(storageDialogControllers.ProviderConfig).get(input.controller)?.errors?.errorWithInfo ? input.errorInfo : input.info) | translate"
                    class="storage-edit-dialog-content-item-header-popover">
                  </div>
                </fw-popover>
              </ng-container>

              <span *ngIf="!input.isRequired"
                class="optional">({{'storageEditDialog.labels.optional' | translate}})</span>

            </div>
            <div class="storage-edit-dialog-content-item-header-description"> {{input.description | translate}}</div>
          </div>
          <ng-container *ngIf="input.options; else textInput">
            <fw-select class="storage-edit-dialog-content-item-select" width="100%"
              [placeholder]="input.placeholder ? (input.placeholder | translate) : ''"
              [formControlName]="input.controller">
              <fw-menu-item [title]="option.label | translate" [value]="option.value"
                *ngFor="let option of input.options"></fw-menu-item>
            </fw-select>
          </ng-container>
          <ng-template #textInput>
            <ng-container *ngIf="{errorText: getProviderConfigControllerError(input.controller)} as error">
              <fw-wrapped-input [errorText]="error.errorText">
                <fw-text-input (focusout)="onTextInputFocusOut(input.controller)"
                  [useActionableIcons]="input.controller === storageDialogControllers.ApplicationCredentials"
                  (rightIconAction)="input.controller === storageDialogControllers.ApplicationCredentials ? onUploadClick() : undefined"
                  [rightIcon]="input.controller === storageDialogControllers.ApplicationCredentials ? 'upload' : undefined"
                  [type]="input.type" (keydown)="removePasswordMask(input.controller)" [maxLength]="null"
                  *ngIf="input.controller !== storageDialogControllers.Groups;else groups"
                  [placeholder]="input.placeholder ? (input.placeholder | translate) : ''"
                  [formControlName]="input.controller">
                </fw-text-input>
              </fw-wrapped-input>
            </ng-container>
          </ng-template>
          <ng-template #groups>
            <fw-chip-input [isError]="isGroupsError" [isWithBorder]="true" [validators]="supplementalGroupIDValidators"
              (inputChange)="currentUidValue = $event"
              [placeholder]="form.controls.providerConfig.get(storageDialogControllers.Groups).value?.length ? '' : input.placeholder | translate"
              [formControlName]="input.controller"></fw-chip-input>
          </ng-template>

          <div
            *ngIf="(form.controls.providerType?.value === storageConfigType.S3 || form.controls.providerType?.value === storageConfigType.AZ) && input.controller === storageDialogControllers.Prefix"
            class="storage-edit-dialog-content-item-switch">
            <fw-switch [title]="'storageEditDialog.labels.connectorCreds' | translate"
              [formControlName]="storageDialogControllers.ConnectorCreds"></fw-switch>
          </div>
        </div>
      </ng-container>
      <div class="storage-edit-dialog-content-item">
        <fw-form-heading [description]="'storageEditDialog.descriptions.permissions' | translate"
          [title]="'storageEditDialog.labels.permissions' | translate"></fw-form-heading>
        <fw-radio-group color="primary" [formControlName]="storageDialogControllers.PermissionLevel"
          [value]="form.get(storageDialogControllers.PermissionLevel).value">
          <fw-radio-button [title]="'storageEditDialog.permissions.site' | translate"
            [value]="permissionLevelEnum.Site"></fw-radio-button>
          <fw-radio-button [title]="'storageEditDialog.permissions.group' | translate"
            [value]="permissionLevelEnum.Group"></fw-radio-button>
          <fw-radio-button [title]="'storageEditDialog.permissions.project' | translate"
            [value]="permissionLevelEnum.Project"></fw-radio-button>
        </fw-radio-group>
      </div>
      <div *ngIf="permissionLevel !== permissionLevelEnum.Site">
        <fw-select *ngIf="permissionLevel === permissionLevelEnum.Group"
          [placeholder]="'storageEditDialog.placeholders.group' | translate"
          [formControlName]="storageDialogControllers.ContainerRef" optionsWidth="567px" width="100%">
          <fw-menu-item *ngFor="let group of groupOptions" [value]="group.value" [title]="group.label">
          </fw-menu-item>
        </fw-select>

        <fw-select test-id="storage-project-select" *ngIf="permissionLevel === permissionLevelEnum.Project"
          [placeholder]="'storageEditDialog.placeholders.project' | translate"
          [formControlName]="storageDialogControllers.ContainerRef" maxOptionsHeight="400px" optionsWidth="567px"
          width="100%">
          <fw-menu-item-group *ngFor="let projectGroup of projectOptions" [title]="projectGroup.title">
            <fw-menu-item *ngFor="let item of projectGroup.options" [title]="item.label" [value]="item.value"
              size="compact"></fw-menu-item>
          </fw-menu-item-group>
        </fw-select>
      </div>
      <div>
        <fw-switch [title]="'storageEditDialog.labels.importsEnabled' | translate"
          [formControlName]="storageDialogControllers.ImportsEnabled"></fw-switch>
      </div>
      <div>
        <fw-switch [title]="'storageEditDialog.labels.exportsEnabled' | translate"
          [formControlName]="storageDialogControllers.ExportsEnabled"></fw-switch>
      </div>
      <fw-tooltip [title]="isMalwareScanningEnabled ? '' : 'storageEditDialog.tooltips.malwareScanning' | translate"
        color="light" [maxWidth]="400">
        <mat-checkbox [formControlName]="storageDialogControllers.MalwareScanning">
          {{'storageEditDialog.labels.malwareScanning' | translate}}
        </mat-checkbox>
      </fw-tooltip>
    </form>
  </fw-dialog-content>
  <fw-dialog-actions>
    <fw-button variant="outline" (click)=close()>
      {{ (form.dirty ? 'common.actions.cancel' : 'common.actions.close') | translate }}
    </fw-button>
    <fw-button (click)="saveChanges()" [disabled]="isSubmitButtonDisabled">
      {{ 'storageEditDialog.actions.saveTest' | translate }}
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>
